/* InputTextTagsControlComponent.js */

/*jshint esversion: 6 */
"use strict";

const InputBaseControlTextfieldComponent = require("@gluenetworks/input_base_control").Textfield;
const Renderer = require("./InputTextTagsControlRenderer");
const _ = require("lodash");

class InputTextTagsControlComponent extends InputBaseControlTextfieldComponent {
    /**
     * @schema.name Input Text Control
     * @schema.package @gluenetworks/input_text_tags_control
     * @schema.namespace require("@gluenetworks/input_text_tags_control")
     *
     */

    constructor(configOptions) {
        super(configOptions);
        this._showErrorMessage = _.get(configOptions, "showErrorMessage", true);
        this.readOnly = _.get(configOptions, "readOnly", false);
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/

    get showErrorMessage() {
        return this._showErrorMessage;
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._invalid = undefined;
            this._visible = undefined;
            this._value = undefined;
            this._darkTheme = undefined;
            this._theme = undefined;
            this.readOnly = undefined;
            this._showErrorMessage = undefined;
            this._required = undefined;
            this._DEFAULT_PLACEHOLDER = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    setReadOnly(newVal) {
        this.emit("ReadOnly", newVal);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = InputTextTagsControlComponent;
